import React, { FC } from 'react';

import { SidePanelHeaderProps } from './SidePanel.types';

import './sidepanel.scss';

export const SidePanelHeader: FC<SidePanelHeaderProps> = ({
	style = {},
	children,
}) => {
	return (
        <div 
            className="gtc-rc-side-panel-header" 
            style={style}
        >
                {children}
        </div>
    )
};